import * as React from 'react';
import { useState, useEffect } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  Container, Box, Typography, IconButton, Dialog, DialogActions, DialogContent,
  DialogContentText, DialogTitle, Button, Modal, TextField, Grid, Alert
} from '@mui/material';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';

import UserService from "../services/user.service";
import { useNavigate } from 'react-router-dom';

export default function Admin() {
  const [users, setUsers] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  // State für Edit-Modal
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    GetUsers();
  }, []);

  const GetUsers = async () => {
    setUsers(await UserService.getAllUsers());
  };

  const handleDeleteUser = async () => {
    try {
      await UserService.deleteUserById(selectedUserId);
      setUsers(users.filter(user => user.userId !== selectedUserId));
      setOpenDialog(false);
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  const handleOpenDialog = (userId) => {
    setSelectedUserId(userId);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedUserId(null);
  };

  // Öffnet das Edit-Modal mit den User-Daten
  const handleOpenEditModal = (user) => {
    setSelectedUser(user);
    setOpenEditModal(true);
  };

  const handleCloseEditModal = () => {
    setOpenEditModal(false);
    setSelectedUser(null);
  };

  return (
    <Box sx={{ background: "#F0F2F5", py: 5 }}>
      <Container maxWidth="xl">
        <Typography variant='h4' mb={5}>Admin Dashboard</Typography>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Rolle</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Kunde</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>E-Mail</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>SharePointSecret</TableCell>
                <TableCell align="right" sx={{ fontWeight: "bold" }}>Letzter Login</TableCell>
                <TableCell align="right" sx={{ fontWeight: "bold" }}>Tools</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map((row) => (
                <TableRow key={row.userId}>
                  <TableCell>{row.role}</TableCell>
                  <TableCell>{row.firstname} {row.lastname}</TableCell>
                  <TableCell>{row.email}</TableCell>
                  <TableCell>{row.secret}</TableCell>
                  <TableCell align="right">{row.lastLogin}</TableCell>
                  <TableCell align="right" sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexDirection: 'row' }}>
                    <IconButton color="primary" aria-label="edit" onClick={() => handleOpenEditModal(row)}>
                      <EditIcon />
                    </IconButton>
                    {row.role !== 'admin' && (
                      <IconButton onClick={() => handleOpenDialog(row.userId)} color="error" aria-label="delete">
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>

      {/* AdminEditModal */}
      {openEditModal && selectedUser && (
        <EditUserModal user={selectedUser} onClose={handleCloseEditModal} />
      )}

      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Benutzer löschen</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Bist du sicher, dass du diesen Benutzer löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">Abbrechen</Button>
          <Button onClick={handleDeleteUser} color="error">Löschen</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

// ---- Edit Modal ----
function EditUserModal({ user, onClose }) {
  const [firstname, setFirstname] = useState(user.firstname);
  const [lastname, setLastname] = useState(user.lastname);
  const [phone, setPhone] = useState(user.phone);
  const [email, setEmail] = useState(user.email);
  const [mobile, setMobile] = useState(user.mobile);
  const [adress, setAdress] = useState(user.adresse);
  const [zip, setZip] = useState(user.zip);
  const [ort, setOrt] = useState(user.ort);
  const [secret, setSecret] = useState(user.secret);
  const [isFormSuccess, setIsFormSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsFormSuccess(true);
    await UserService.ADMIN_updateUser(user.userId, firstname, lastname, phone, email, mobile, adress, zip, ort, secret);
    setTimeout(() => {
      navigate('/admin');
      window.location.reload();
    }, 1500);
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    p: 4,
  };

  return (
    <Modal open={true} onClose={onClose}>
      <Container sx={style}>
          <Typography variant="h6" align="center">
            Ihre Daten ändern
          </Typography>
          <form autoComplete="off" onSubmit={handleSubmit}>
            <Grid container mt={3} rowSpacing={2} columnSpacing={2} justifyContent="center">
              <Grid item xs={12} md={6}>
                <TextField fullWidth required label="Vorname" variant="outlined" value={firstname} onChange={(e) => setFirstname(e.target.value)} />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField fullWidth required label="Nachname" variant="outlined" value={lastname} onChange={(e) => setLastname(e.target.value)} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField fullWidth label="Telefon" variant="outlined" value={phone} onChange={(e) => setPhone(e.target.value)} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField fullWidth required label="E-Mail" variant="outlined" value={email} onChange={(e) => setEmail(e.target.value)} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField fullWidth label="Mobil" variant="outlined" value={mobile} onChange={(e) => setMobile(e.target.value)} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField fullWidth required label="Adresse" variant="outlined" value={adress} onChange={(e) => setAdress(e.target.value)} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField fullWidth required label="PLZ" variant="outlined" value={zip} onChange={(e) => setZip(e.target.value)} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField fullWidth required label="Ort" variant="outlined" value={ort} onChange={(e) => setOrt(e.target.value)} />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField fullWidth label="SharePoint Secret" variant="outlined" value={secret} onChange={(e) => setSecret(e.target.value)} />
              </Grid>
            </Grid>
            <Box mt={4} textAlign="center">
              <Button type="submit" variant="contained" color="primary">
                Speichern
              </Button>
            </Box>
          </form>
          <Box mt={4}>{isFormSuccess && <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">Das Formular wurde erfolgreich abgeschickt. Vielen Dank!</Alert>}</Box>
        </Container>
    </Modal>
  );
}
